import { render, staticRenderFns } from "./TaskManagerCalendar.vue?vue&type=template&id=2060820c&scoped=true"
import script from "./TaskManagerCalendar.vue?vue&type=script&lang=js"
export * from "./TaskManagerCalendar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2060820c",
  null
  
)

export default component.exports